module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/gems/border-default-120.png"+" 120w",
        images: [{path: __webpack_public_path__ + "assets/images/gems/border-default-120.png",width: 120,height: 120}],
        src: __webpack_public_path__ + "assets/images/gems/border-default-120.png",
        toString: function(){return __webpack_public_path__ + "assets/images/gems/border-default-120.png"},
        
        width: 120,
        height: 120
      }